module.exports = {
    sponsoredAds: {
        sponsoredProductText: 'Sponsored',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/sponsored-ads.js